import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularClockPlusOutline: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_clock-plus-outline"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="clock-plus-outline icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 21 20"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.25 9C19.25 4.58172 15.6683 1 11.25 1C6.83172 1 3.25 4.58172 3.25 9C3.25 9.19805 3.2572 9.39442 3.27134 9.58886C3.58271 9.4314 3.91109 9.30268 4.25298 9.20619C4.251 9.1377 4.25 9.06897 4.25 9C4.25 5.13401 7.38401 2 11.25 2C15.116 2 18.25 5.13401 18.25 9C18.25 12.866 15.116 16 11.25 16C11.181 16 11.1123 15.999 11.0438 15.997C10.9473 16.3389 10.8186 16.6673 10.6611 16.9787C10.8556 16.9928 11.052 17 11.25 17C15.6683 17 19.25 13.4183 19.25 9ZM11.2419 4.41012C11.1996 4.17688 10.9955 4 10.75 4C10.4739 4 10.25 4.22386 10.25 4.5V9.5L10.2581 9.58988C10.3004 9.82312 10.5045 10 10.75 10H13.75L13.8399 9.99194C14.0731 9.94961 14.25 9.74546 14.25 9.5C14.25 9.22386 14.0261 9 13.75 9H11.25V4.5L11.2419 4.41012ZM10.25 14.5C10.25 16.9853 8.23528 19 5.75 19C3.26472 19 1.25 16.9853 1.25 14.5C1.25 12.0147 3.26472 10 5.75 10C8.23528 10 10.25 12.0147 10.25 14.5ZM5.75 12C5.47386 12 5.25 12.2239 5.25 12.5V14H3.75C3.47386 14 3.25 14.2239 3.25 14.5C3.25 14.7761 3.47386 15 3.75 15H5.25V16.5C5.25 16.7761 5.47386 17 5.75 17C6.02614 17 6.25 16.7761 6.25 16.5V15H7.75C8.02614 15 8.25 14.7761 8.25 14.5C8.25 14.2239 8.02614 14 7.75 14H6.25V12.5C6.25 12.2239 6.02614 12 5.75 12Z"
        />
      </svg>
    </span>
  );
};

export { RegularClockPlusOutline };
